import React from 'react';

const FaturamentoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeiro/faturamento',
      component: React.lazy(() => import('./Faturamento')),
    },
  ],
};

export default FaturamentoConfig;
